import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.TwoFaHardEnforcementPage', {
    title: 'Two-factor authentication set up',
});
